import { checkCooperative } from './checkCooperative';
import { checkLinkWithPadPrescription } from './checkLinkWithPadPrescription';
import { checkSuspensionVisit } from './checkSuspensionVisit';

export const shouldIncludeAsVisitPrescriptionScheduleCooperative = padVisit => {
  const isCooperative = checkCooperative(padVisit);
  const hasLinkWithPadPrescription = checkLinkWithPadPrescription(padVisit);
  const isSuspensionVisit = checkSuspensionVisit(padVisit);

  return isCooperative && !isSuspensionVisit && hasLinkWithPadPrescription;
};
